// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rbdH","right":"Footer_right__2pIBw","buttons":"Footer_buttons__lBBTa"};